export default {
	name: '项目灰度环境',
	test: [ 'https?://beta.yunztech.com' ],
	BASE: 'https://center.yunztech.com/', //MA通用接口
	ZUKER: 'https://ma-api.yunztech.com/', //租客相关接口
	DATA: 'https://ma-api.yunztech.com/', //首页统计接口
	HOME_ANALYSIS: 'https://ma-api.yunztech.com/', //首页统计接口
	FACE2FACE: 'https://ma-api.yunztech.com/', //面对面接口
	APPORTION: 'https://ma-api.yunztech.com/', //结算中心-券分摊应用接口
	TASK: 'https://ma-api.yunztech.com/', //下载中心
	ACTIVITY: 'https://center.yunztech.com', //活动管理相关
	MP_API: 'https://portalapi.yunztech.com', //小程序登录
};
